import { getFunctions, httpsCallable } from 'firebase/functions';

export default async function createUser({ email, orgId = null }) {
  if (!email) throw new Error('Email is required to create a user');
  const { data } = await httpsCallable(getFunctions(), 'adminCreateUserV2')({ email, orgId });
  return data;
}
